import { render, staticRenderFns } from "./CustomerInstallationAddress.vue?vue&type=template&id=2db84572&scoped=true&"
import script from "./CustomerInstallationAddress.vue?vue&type=script&lang=ts&"
export * from "./CustomerInstallationAddress.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerInstallationAddress.vue?vue&type=style&index=0&id=2db84572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db84572",
  null
  
)

export default component.exports